<template>
  <div class="container-fluid p-2 order-create">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    >
    </loading>
    <h5 class="text-muted mr-auto p-2">
      <h2 v-if="order.status === 'new'">{{ $t("buttons.beginOrder") }}</h2>
      <h2 v-else-if="order.status === 'edit'">
        {{ $t("buttons.editOrder") }} - <small>{{ order.increment_id }}</small>
        <br />
      </h2>
      <h2 v-else-if="order.status === 'create'">
        {{ $t("buttons.createInvoice") }}
      </h2>
      <h2 v-else-if="order.status === 'createInvoice'">
        {{ $t("buttons.createInvoice") }}
      </h2>

      <small>
        {{ order.customer.cardCode }} - {{ order.customer.company }}
      </small>
    </h5>
    <validation-observer ref="v-observer" class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-3 col-12">
            <div class="input-group-prepend">
              <label
                class="input-group-text order-proposal-shipping"
                for="proposalShipping"
                >{{ $t("customer.selectShippingAddressToOrder") }}</label
              >
            </div>
          </div>
          <div class="col-sm-8 col-12">
            <validation-provider v-slot="v" slim rules="required">
              <multiselect
                id="proposalShipping"
                class="form-control-sm form-control-select textarea"
                :class="{
                  'is-invalid': v.errors.length,
                }"
                :placeholder="$t('buttons.selectAddress')"
                :value="selectedOption"
                :options="selectOptions"
                track-by="id"
                label="name"
                :searchable="true"
                deselectLabel=""
                selectLabel=""
                @input="selectShipment($event)"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="row">
          <div class="col-sm-6 col-12 input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="commentsGroup">{{
                $t("basket.comment")
              }}</label>
            </div>
            <textarea
              id="commentsGroup"
              rows="5"
              cols="100"
              class="w-auto"
              :value="order.comment"
              :maxlength="254"
              @change="changeCommentState"
            />
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="col">
          <div class="text-center">
            <button
              class="btn btn-secondary m-1 hideToSummaryBack"
              @click="backStep"
            >
              {{ $t("buttons.backToCustomer") }}
            </button>
            <button
              class="btn btn-theme-add m-1 hideToSummary"
              @click="nextStep"
            >
              {{ $t("buttons.nextStep") }}
            </button>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import { currencyMixin } from "../mixins";
import Multiselect from "vue-multiselect";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Checkout",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect,
    Loading,
  },
  mixins: [currencyMixin],
  data() {
    return {
      shippingOption: [
        { value: "16" },
        { value: "13" },
        { value: "12" },
        { value: "11" },
        // { value: "10" },
        { value: "9" },
        { value: "8" },
        { value: "7" },
        { value: "6" },
        { value: "5" },
        { value: "4" },
        { value: "3" },
        { value: "2" },
        { value: "1" },
      ],
      paymentList: [],
      customerPayment: this.payment,
      isLoading: false,
      fullPage: true,
      globalRoadSystem: false,
      showDocRate: false,
    };
  },
  computed: {
    ...mapState("currency", ["currency", "ratio"]),
    ...mapState("cart", ["order"]),
    ...mapGetters("cart", [
      "totalPrice",
      "transport",
      "currentCustomer",
      "specialOrder",
      "payment",
      "docToSend",
      "salesOrderReal",
    ]),
    ...mapGetters("auth", ["paymentCustomer"]),
    ...mapGetters("customers", {
      customerShipping: "shipping",
    }),
    selectOptions() {
      let a = [];
      a = [] = this.customerShipping
        ? this.customerShipping.map((shipObject) => ({
            name:
              shipObject.addressName +
              " - " +
              shipObject.city +
              " " +
              shipObject.street,
            id: shipObject.addressId,
          }))
        : [];
      return a;
    },
    selectedOption() {
      return this.selectOptions.find(
        (el) => el.id === this.order.shipping.addressId
      );
    },
  },
  methods: {
    ...mapActions({
      clearCart: "cart/clearCartData",
    }),
    ...mapMutations("cart", [
      "setPayment",
      "setShipping",
      "setComment",
      "setShippingValue",
      "setProposalTime",
      "setPrepayment",
      "setShippingCity",
      "setDocRate",
      "setTransportRequired",
      "setReferenceNumber",
      "setInvoiceForTransport",
      "setSalesOrderReal",
      "setDocToSend",
      "setSpecialOrder",
      "setStatus",
      "setType",
    ]),
    async backStep() {
      this.$router.push({
        name: "customer",
        params: {
          id: this.order.customer.customerId,
        },
      });
    },
    async nextStep() {
      this.$refs["v-observer"].validate().then(async (result) => {
        if (result) {
          this.$router.push({
            name: "products",
          });
        }
      });
    },
    changePaymentState: function(event) {
      this.setPayment(event.target.value);
    },
    changeShippingState: function(event) {
      this.setShippingValue(event.target.value);
    },
    changeProposalTime: function(event) {
      this.setProposalTime(event.target.value);
    },
    changePrepayment: function(event) {
      this.setPrepayment(event.target.value);
    },
    changeShippingCity: function(event) {
      this.setShippingCity(event.target.value);
    },
    changeDocRate: function(event) {
      this.setDocRate(event.target.value);
    },
    changeCommentState: function(event) {
      this.setComment(event.target.value);
    },
    changeTransportRequired: function(event) {
      this.setTransportRequired(event.target.value);
    },
    changeInvoiceForTransport: function(event) {
      this.setInvoiceForTransport(event.target.value);
    },
    changeSalesOrderReal: function(event) {
      this.setSalesOrderReal(event.target.value);
    },
    changeDocToSend: function(event) {
      this.setDocToSend(event.target.value);
    },
    changeSpecialOrder: function(event) {
      if (event.target.checked) {
        this.setSpecialOrder("Y");
      } else {
        this.setSpecialOrder("N");
      }
    },
    changeReferenceNumber: function(event) {
      this.setReferenceNumber(event.target.value);
    },
    selectShipment(value) {
      this.isLoading = true;
      this.setShipping(
        this.customerShipping.find(
          (shipObject) => shipObject.addressId === value.id
        )
      );
      this.isLoading = false;
    },
    filterPayment: function(event) {
      const customerPayment = this.$store.getters["auth/paymentCustomer"];
      const displayPayments = this.$store.getters["auth/paymentList"];
      const payments = displayPayments.filter(function(payment) {
        if (
          ["-1", "4", "8", "10", customerPayment].includes(payment.docEntry)
        ) {
          return payment;
        }
      });
      this.paymentList = payments;
    },
    checkPayment: function(event) {
      if (this.$store.getters["cart/payment"] == "") {
        this.setPayment(this.paymentCustomer);
      }
    },
    checkDocToSend: function(event) {
      if (this.$store.getters["cart/docToSend"] == "") {
        this.setDocToSend(this.currentCustomer.defaultDocSend);
      }
    },
    checkSalesOrderReal: function(event) {
      if (this.$store.getters["cart/salesOrderReal"] == "") {
        this.setSalesOrderReal(this.currentCustomer.defaultZSReal);
      }
    },
    checkSpecialOrder: function(event) {
      if (this.$store.getters["cart/specialOrder"] == "Y") {
        document.getElementById("specialOrder").checked = true;
      } else {
        document.getElementById("specialOrder").checked = false;
      }
    },
    checkInvoiceForTransport: function(event) {
      if (this.globalRoadSystem) {
        this.setInvoiceForTransport("0");
      }
    },
    checkPrePayment: function(event) {
      if (this.globalRoadSystem) {
        this.setPrepayment("N");
      }
    },
    showRate: function(event) {
      if (this.order.type == "invoice" && this.customer.country != "PL") {
        this.showDocRate = true;
      }
    },
  },
  mounted() {
    this.checkDocToSend();
    this.checkSalesOrderReal();
    this.filterPayment();
    this.checkPayment();
    this.checkInvoiceForTransport();
    this.checkPrePayment();
    this.showRate();

    // this.customerPayment = this.paymentCustomer;
  },
};
</script>
<style scoped>
.form-check-input {
  position: absolute;
  margin-top: 0.3 rem;
  margin-right: 0px;
  width: 32px !important;
  height: 30px !important;
  margin-left: 0px;
}
</style>
